import React, { useState } from 'react';
import { FormFieldset } from '@tesla/design-system-react';
import { FormField } from 'informed';
import { shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import messages from './messages';
import eeoMessages from './eeo-v1.json';
import formStyle from '../../JobApplicationForm/style.module.scss';
import { Disclaimer } from '../../index';
import { useTCLFormApi } from '../../../hooks';

const EEOSection = ({ fields }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const formHelper = useTCLFormApi();
  const [hasReadDisclaimer, setHasReadDisclaimer] = useState(false);

  const validateEEOAcknowledgment = (value) =>
    value !== true ? formatMessage(messages.AcknowledgmentRequiredMessage) : undefined;

  return (
    <>
      <FormFieldset className={formStyle.FormSection}>
        <Disclaimer hasRead={setHasReadDisclaimer}>
          <h3 className="tds-text--h5">{eeoMessages.Intro.Heading}</h3>
          <p>{eeoMessages.Intro.Copy}</p>

          <h3 className="tds-text--h5">{eeoMessages.Definitions.RaceEthnicity.Heading}</h3>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: eeoMessages.Definitions.RaceEthnicity.Copy }} />
          <h3 className="tds-text--h5">{eeoMessages.Definitions.VeteranStatus.Heading}</h3>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: eeoMessages.Definitions.VeteranStatus.Copy }} />

          <h3 className="tds-text--h5">{eeoMessages.DisabilityStatus.Heading}</h3>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: eeoMessages.DisabilityStatus.Copy }} />

          <h3 className="tds-text--h5">{eeoMessages.ReasonableAccommodationStatement.Heading}</h3>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: eeoMessages.ReasonableAccommodationStatement.Copy }}
          />
          <h3 className="tds-text--h5">{eeoMessages.OFCCPNotice.Heading}</h3>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: eeoMessages.OFCCPNotice.Copy }} />
        </Disclaimer>

        {!hasReadDisclaimer && (
          <FormField
            {...{
              ...formHelper.field(fields.eeoAcknowledgment),
              schema: {
                ...formHelper.field(fields.eeoAcknowledgment).schema,
                properties: {
                  ...formHelper.field(fields.eeoAcknowledgment).schema.properties,
                  eeoAcknowledgment: {
                    ...formHelper.field(fields.eeoAcknowledgment).schema.properties
                      .eeoAcknowledgment,
                    'ui:props': {
                      ...formHelper.field(fields.eeoAcknowledgment).schema.properties
                        .eeoAcknowledgment['ui:props'],
                      disabled: true,
                    },
                  },
                },
              },
            }}
          />
        )}
        {hasReadDisclaimer && (
          <FormField
            {...formHelper.field(fields.eeoAcknowledgment)}
            validate={validateEEOAcknowledgment}
          />
        )}
      </FormFieldset>

      <FormFieldset className={formStyle.FormSection}>
        <div className="tds-form-layout--multicolumn tds-layout tds-layout-2col">
          <FormField {...formHelper.field(fields.eeoGender)} />
          <FormField {...formHelper.field(fields.eeoVeteranStatus)} />
        </div>

        <div className="tds-form-layout--multicolumn tds-layout tds-layout-2col">
          <FormField {...formHelper.field(fields.eeoRaceEthnicity)} />
          <FormField {...formHelper.field(fields.eeoDisabilityStatus)} />
        </div>

        <div className={formStyle.FormFieldHalfWidth}>
          <FormField {...formHelper.field(fields.eeoDisabilityStatusName)} />
        </div>
      </FormFieldset>
    </>
  );
};

EEOSection.propTypes = {
  fields: shape({
    eeoAcknowledgment: string,
    eeoGender: string,
    eeoRaceEthnicity: string,
    eeoVeteranStatus: string,
    eeoDisabilityStatus: string,
    eeoDisabilityStatusName: string,
    eeoDisabilityStatusDate: string,
  }).isRequired,
};

export default EEOSection;
